import React from 'react';
import { useTranslation } from 'react-i18next';
import { TitleHeader } from 'web-library';
import AddCandidateBlacklist from '../../modules/admin/components/CandidateBlacklist/AddCandidateBlacklist';

const AddCandidateBlacklistPage = () => {
  const { t } = useTranslation();
  return (
    <>
      <TitleHeader title={t('admin->>CandidateBlacklist.AddCandidateToBlacklist')} />
      <AddCandidateBlacklist />
    </>
  );
};

export default AddCandidateBlacklistPage;
